export default {
  options (h, conf) {
    const list = [];
    conf.__slot__.options.forEach(item => {
      list.push(<el-option label={item.label} value={item} disabled={item.disabled}></el-option>);
    });
    return list;
  },
};
